import { render, staticRenderFns } from "./CategoryColumn.vue?vue&type=template&id=5415548a&scoped=true"
import script from "./CategoryColumn.vue?vue&type=script&lang=js"
export * from "./CategoryColumn.vue?vue&type=script&lang=js"
import style0 from "./CategoryColumn.vue?vue&type=style&index=0&id=5415548a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5415548a",
  null
  
)

export default component.exports